import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { AuthLayout, GoogleIcon, startGoogleLogin } from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { LOGIN, AUTH } from "@/constants/testIds";

export default function LoginPage() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(errorMessage(err, "Accesso non riuscito"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Bentornato" subtitle="Accedi per continuare la raccolta dati dei tuoi pazienti.">
      <Button type="button" variant="secondary" className="w-full h-11 justify-center gap-2" onClick={startGoogleLogin} data-testid={AUTH.googleButton}>
        <GoogleIcon /> Continua con Google
      </Button>
      <div className="flex items-center gap-3 my-6">
        <Separator className="flex-1" />
        <span className="text-xs text-muted-foreground uppercase tracking-wider">oppure</span>
        <Separator className="flex-1" />
      </div>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@clinica.it" className="h-11 bg-card" data-testid={LOGIN.emailInput} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-11 bg-card" data-testid={LOGIN.passwordInput} />
        </div>
        <Button type="submit" className="w-full h-11" disabled={busy} data-testid={LOGIN.submitButton}>
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Accedi
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-8 text-center">
        Non hai un account?{" "}
        <Link to="/register" className="text-primary font-medium hover:underline" data-testid={LOGIN.registerLink}>Registrati</Link>
      </p>
    </AuthLayout>
  );
}
